import { Controller } from "@hotwired/stimulus"

// Opens an in-page modal that plays the video at the URL passed via
// data-clip-preview-url-param. Designed for the character-clips admin
// index where each thumbnail triggers this on click. Pauses + releases
// the video src on close so memory doesn't accumulate.
//
// Markup (one modal per page):
//   <div data-controller="clip-preview"
//        data-clip-preview-target="container"
//        class="hidden fixed inset-0 z-50 bg-black/75 ...">
//     <div data-clip-preview-target="panel" ...>
//       <video data-clip-preview-target="video" controls autoplay
//              class="w-full h-full"></video>
//       <button data-action="click->clip-preview#close">×</button>
//     </div>
//   </div>
//
//   <button data-action="click->clip-preview#open"
//           data-clip-preview-url-param="/rails/active_storage/.../clip.mp4">
//     <img src="thumb.png" />
//   </button>
export default class extends Controller {
  static targets = ["container", "panel", "video"]

  connect() {
    this.handleBackdropClick = this.handleBackdropClick.bind(this)
    this.handleEscape = this.handleEscape.bind(this)
  }

  open(event) {
    event.preventDefault()
    const url = event.params.url
    if (!url) return
    this.videoTarget.src = url
    this.containerTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
    this.containerTarget.addEventListener("click", this.handleBackdropClick)
    document.addEventListener("keydown", this.handleEscape)
    const playPromise = this.videoTarget.play()
    if (playPromise && playPromise.catch) {
      playPromise.catch(() => { /* autoplay blocked; user can press play */ })
    }
  }

  close() {
    this.containerTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
    this.containerTarget.removeEventListener("click", this.handleBackdropClick)
    document.removeEventListener("keydown", this.handleEscape)
    this.videoTarget.pause()
    this.videoTarget.removeAttribute("src")
    this.videoTarget.load() // drops buffered content so memory doesn't accumulate
  }

  handleBackdropClick(event) {
    if (!this.panelTarget.contains(event.target)) {
      this.close()
    }
  }

  handleEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
